module.exports = __webpack_public_path__ + "img/book.ea557d86.svg";